if (!customElements.get('ly-showroom-search')) {
    customElements.define('ly-showroom-search', class extends HTMLElement {
        async connectedCallback() {
            this.input = this.querySelector('input')

            // Request needed libraries.
            await google.maps.importLibrary('places')

            const autocomplete = new google.maps.places.Autocomplete(this.input)

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace()
                const { lng, lat } = place.geometry.location
                window.location = location.origin + `/pages/showrooms/?lng=${lng()}&lat=${lat()}`
            })
        }
    })
}